<template>
  <v-btn flat :fab="fab" small color="accent"
         class="ma-0"
         @click="showDialog = true">
    <v-icon>headset_mic</v-icon>
    <template v-if="!fab">
       Contact info
    </template>
    <v-dialog v-model="showDialog"
              v-if="vendorDispatcher"
              lazy
              max-width="500">
      <v-card :class="{'pa-4': !$vuetify.breakpoint.smAndDown}">
        <v-layout column>
          <v-toolbar extended dense>
            <v-icon color="accent">headset_mic</v-icon>
            <v-toolbar-title>{{ vendorDispatcher.name }}</v-toolbar-title>
            <v-list slot="extension">
              <v-list-tile class="pl-2">
                <v-list-tile-content>
                  <v-list-tile-sub-title class="font-italic">
                    Dispatcher Contact Info
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-toolbar>
          <v-spacer class="mb-3" />

          <v-card pa-0 flat>
            <v-text-field v-model="name"
                          :readonly="!hasOfficePerm" label="Name"></v-text-field>
            <v-text-field v-model="email"
                          :readonly="!hasOfficePerm" label="Email"></v-text-field>
            <v-text-field v-model="phone"
                          :readonly="!hasOfficePerm"
                          label="Phone (for SMS Texts)">
            </v-text-field>
          </v-card>

          <v-card-actions v-if="hasOfficePerm" class="align-right">
            <v-btn color="accent"
                   :loading="loadingBtn"
                   flat large outline
                   @click="showDialog = false">
              <v-icon large class="pr-2">cancel</v-icon>
              Cancel
            </v-btn>
            <v-btn color="accent"
                   :loading="loadingBtn"
                   large
                   @click="save">
              <v-icon large class="pr-2">save</v-icon>
              Save
            </v-btn>
          </v-card-actions>
        </v-layout>
      </v-card>
    </v-dialog>
  </v-btn>
</template>

<script>
import _ from 'lodash';
import API from '@/api';
import { mapGetters } from 'vuex';
import { accountHasOfficePermission } from '@/store/permissions';
import QuickbooksMixin from '@/mixins/quickbooksMixin';

export default {
  name: 'DispatcherInfo',
  props: {
    vendorDispatcher: {
      type: Object,
      required: true,
    },
    company: {
      type: Object,
      required: true,
    },
    fab: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [
    QuickbooksMixin,
  ],
  data() {
    return {
      loadingBtn: false,
      showDialog: false,
      name: null,
      email: null,
      phone: null,
    };
  },
  computed: {
    hasOfficePerm() {
      return accountHasOfficePermission(this.findCompanyAccount()(this.company.id));
    },
  },
  watch: {
    vendorDispatcher: {
      handler() {
        this.initForm();
      },
      deep: true,
    },
  },
  methods: {
    ...mapGetters('profiles', [
      'findCompanyAccount',
    ]),
    async save() {
      try {
        const body = {
          companyId: this.vendorDispatcher.id,
          companyName: this.vendorDispatcher.name,
          name: this.name,
          email: this.email,
          phone: this.phone,
        };

        this.loadingBtn = true;
        await API.quickBooks.updateVendorDispatcher(
          this.company.id,
          this.vendorDispatcher.id,
          body);

        this.$store.dispatch('applications/setSuccessNotification', {
          message: 'Dispatcher Contact info saved',
        });

        this.showDialog = false;
        this.refreshQuickbooksVendors(this.company.id);
      } catch (error) {
        this.$store.dispatch('applications/setErrorNotification', {
          message: error.message,
        });
      } finally {
        this.loadingBtn = false;
      }
    },
    initForm() {
      console.log('Vendor info: ', this.vendorDispatcher);
      this.name = _.get(this.vendorDispatcher, 'contacts[0].name', null);
      this.email = _.get(this.vendorDispatcher, 'contacts[0].email', null);
      this.phone = _.get(this.vendorDispatcher, 'contacts[0].phone', null);
    },
  },
  created() {
    this.initForm();
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/qb/DispatcherInfo.vue